'use strict';

module.exports = function defined() {
	for (var i = 0; i < arguments.length; i++) {
		if (typeof arguments[i] !== 'undefined') {
			return arguments[i];
		}
	}
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/defined/index.js
 ** module id = 1576
 ** module chunks = 0
 **/